import { useI18n } from "../i18n";
import { Instagram, Youtube, Send } from "lucide-react";

const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-black/60 backdrop-blur-sm" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="font-display text-6xl md:text-8xl tracking-tighter">
              ASTANA<span className="text-[#FFDE00]">.</span>
            </div>
            <p className="mt-3 text-white/50 text-sm tracking-widest uppercase">
              {t.footer.built}
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] tracking-widest uppercase text-white/40 mb-3">
              Navigate
            </div>
            <ul className="space-y-2">
              {["tour", "about", "videos", "gallery", "press", "contact"].map((k) => (
                <li key={k}>
                  <a
                    href={`#${k}`}
                    className="text-sm text-white/70 hover:text-[#FFDE00] uppercase tracking-wide"
                  >
                    {t.nav[k]}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] tracking-widest uppercase text-white/40 mb-3">
              Follow
            </div>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/team_astana"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 border border-white/15 flex items-center justify-center hover:bg-[#FFDE00] hover:text-black hover:border-[#FFDE00] transition-all"
              >
                <Instagram size={14} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-9 h-9 border border-white/15 flex items-center justify-center hover:bg-[#FFDE00] hover:text-black hover:border-[#FFDE00] transition-all"
              >
                <Youtube size={14} />
              </a>
              <a
                href="https://t.me/team_astana"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
                className="w-9 h-9 border border-white/15 flex items-center justify-center hover:bg-[#FFDE00] hover:text-black hover:border-[#FFDE00] transition-all"
              >
                <Send size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40 tracking-widest uppercase">
          <div>
            © {year} Astana. {t.footer.rights}
          </div>
          <div>Built for the road · 2026</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
